
import React from 'react';

const LoadingState = () => {
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-10rem)]">
      <div className="animate-pulse text-center">
        <div className="h-8 bg-slate-200 dark:bg-nalc-dark/40 rounded w-48 mx-auto mb-4"></div>
        <div className="h-4 bg-slate-200 dark:bg-nalc-dark/40 rounded w-32 mx-auto"></div>
      </div>
    </div>
  );
};

export default LoadingState;
